import { getInSessionStorage } from "../../helpers";

type GetCurrentBranchArgs = {
  branchFromProps?: string;
  defaultValue: string;
};
export const getCurrentBranch = ({ branchFromProps, defaultValue }: GetCurrentBranchArgs) =>
  branchFromProps ?? getInSessionStorage("branch") ?? defaultValue;
